import { render, staticRenderFns } from "./Magacin.vue?vue&type=template&id=4158dc8f"
import script from "./Magacin.vue?vue&type=script&lang=js"
export * from "./Magacin.vue?vue&type=script&lang=js"
import style0 from "./Magacin.vue?vue&type=style&index=0&id=4158dc8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports